import { Button, LoadingIndicator } from "@light-technology/components";
import { skipToken } from "@reduxjs/toolkit/query/react";
import { ChevronDown, ChevronUp, LinkExternal01 } from "@untitledui/icons";
import { format } from "date-fns";
import { useState } from "react";
import { api } from "../../state/api";
import { type AppAccount, type AppResponse } from "../../state/api.types";
import { ContractStatus } from "./ContractStatus";

type AccountSlideoutContractsProps = {
  account: AppAccount;
  app: AppResponse;
};

export const AccountSlideoutContracts = (
  props: AccountSlideoutContractsProps,
) => {
  const getLocationDocuments = api.useGetLocationDocumentsQuery(
    props.account.locations[0]
      ? {
          appUUID: props.app.uuid,
          accountUUID: props.account.uuid,
          locationUUID: props.account.locations[0].uuid,
        }
      : skipToken,
  );

  const [activeIndex, setActiveIndex] = useState(0);

  if (getLocationDocuments.isLoading) {
    return <LoadingIndicator type="brand-spinner" />;
  }

  if (!getLocationDocuments.data?.data.length) {
    return (
      <div className="text-sm text-tertiary">No contracts for this account</div>
    );
  }

  return (
    <div className="space-y-xl">
      {getLocationDocuments.data.data.map((document, index) => (
        <div
          key={document.uuid}
          className="rounded-xl border border-secondary p-xl"
        >
          <div className="flex items-center gap-md">
            <div className="flex-auto">
              <div className="flex items-center gap-md">
                <div className="text-sm font-medium text-secondary">
                  {document.plan_name}
                </div>
                <ContractStatus contract={document} />
              </div>
              <div className="text-sm text-primary">
                {format(document.contract_start, "PPP")} -{" "}
                {format(document.contract_end, "PPP")}
              </div>
            </div>
            <Button
              className="flex-none"
              color="tertiary"
              iconLeading={index === activeIndex ? ChevronUp : ChevronDown}
              onClick={() => {
                setActiveIndex(index === activeIndex ? -1 : index);
              }}
            />
          </div>
          {index === activeIndex && (
            <div className="mt-3xl space-y-lg">
              <div className="flex items-center justify-between gap-md">
                <div className="text-sm text-secondary">
                  Electricity facts label
                </div>
                <Button
                  color="tertiary"
                  iconLeading={LinkExternal01}
                  href={document.efl}
                  target="_blank"
                  rel="noopener noreferrer"
                />
              </div>
              <div className="flex items-center justify-between gap-md">
                <div className="text-sm text-secondary">Terms of service</div>
                <Button
                  color="tertiary"
                  iconLeading={LinkExternal01}
                  href={document.tos}
                  target="_blank"
                  rel="noopener noreferrer"
                />
              </div>
              <div className="flex items-center justify-between gap-md">
                <div className="text-sm text-secondary">
                  Your rights as a customer
                </div>
                <Button
                  color="tertiary"
                  iconLeading={LinkExternal01}
                  href={document.yrac}
                  target="_blank"
                  rel="noopener noreferrer"
                />
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
